import React from "react";
import styled from "styled-components";

// context
import { useSiteHeader } from "core/SiteHeader/context/useSiteHeader.js";

// components
import TNPLogo from "../TNPLogo";
import TnpLogoType from "./TnpLogoType";
import ProductsMenu from "../../components/ProductsMenu/index";
import RightBlock from "../RightBlock";
import HomeLink from "core/SiteHeader/components/HomeLink.js";

// data
import {
    GAP,
    TNP_LOGO_WIDTH,
    TNP_LOGO_TYPE_WIDTH
} from "core/SiteHeader/TabletDesktop/Layout/constants.js";

// styles
import { convertPxToRem } from "frontend/components/helpers";
import breakpoints from "core/breakpoints";
const Row1Styled = styled.div`
    display: flex;
    gap: ${convertPxToRem(GAP)};
    align-items: center;
    height: ${convertPxToRem(40)};
`;
const HomeLinkStyled = styled(HomeLink)`
    flex: 0 0 ${convertPxToRem(TNP_LOGO_WIDTH)};

    @media (min-width: ${breakpoints.desktop.rem}) {
        flex: 0 0 ${convertPxToRem(TNP_LOGO_WIDTH + TNP_LOGO_TYPE_WIDTH + GAP)};
    }
`;

const LogosWrapperStyled = styled.div`
    display: flex;
    gap: ${convertPxToRem(GAP)};
`;

// component
export const Row1 = () => {
    const { onFocusScrollUp } = useSiteHeader();

    return (
        <Row1Styled>
            <HomeLinkStyled>
                <LogosWrapperStyled>
                    <TNPLogo />
                    <TnpLogoType />
                </LogosWrapperStyled>
            </HomeLinkStyled>
            <ProductsMenu />
            <RightBlock
                onFocusScroll={onFocusScrollUp}
                showMarketingMessageModal
            />
        </Row1Styled>
    );
};

export default Row1;
